export const EventTableTabsStyle = {
	container: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		padding: '24px',
		borderRadius: '8px',
		background: 'var(--default-white)',
		boxShadow: 'var(--box-shadow--1)',
		height: '100%',
		width: '100%',
		'@media (max-width: 1199.98px)': {
			padding: '16px',
		},
		'@media (max-width: 639.98px)': {
			padding: '12px',
		},
	},
	wrapper: {
		width: '100%',
		margin: '0 auto',
		marginBottom: '24px',
		'@media (max-width: 1199.98px)': {
			marginBottom: '16px',
		},
	},

	tabs: {
		background: 'var(--default-white)',
		padding: '24px 0',
		maxHeight: '36px',
		borderRadius: '8px 8px 0 0',
		'@media (max-width: 1199.98px)': {
			padding: '16px 0',
			overflowX: 'auto',
			overflowY: 'hidden',
			'& .MuiTabs-flexContainer': {
				flexWrap: 'nowrap',
				minWidth: 'min-content',
			},
		},
		'@media (max-width: 639.98px)': {
			padding: '12px 0',
		},
	},

	tab: {
		width: '33%',
		zIndex: 99,
		minWidth: 'unset',
		lineHeight: 'normal',

		'@media (max-width: 1199.98px)': {
			minWidth: '100px',
			padding: '6px 12px',
			fontSize: '14px',
		},
		'@media (max-width: 639.98px)': {
			minWidth: '80px',
			padding: '6px 8px',
			fontSize: '13px',
			lineHeight: 'normal',

			'&.Mui-selected': {
				lineHeight: 'normal',
			},
		},
	},

	loader: {
		position: 'absolute',
		left: '50%',
		top: '50%',
	},

	containerWrapper: {
		// height: '100%',
		// position: 'relative',
		position: 'relative',
		width: '100%',
		height: '100%',
		overflow: 'hidden',

		'@media (min-width: 1200px)': {
			// minHeight: 'calc(100vh - 128px)',
			minHeight: 'calc(100vh - 128px)',
			maxHeight: 'fit-content',
		},
	},

	buttonsWrapper: {
		display: 'flex',
		gap: '24px',
		marginTop: 'auto',
		'@media (max-width: 767.98px)': {
			flexDirection: 'column',
			gap: '12px',
			'& button': {
				width: '100%',
			},
		},
	},
};
